import dayjs from "dayjs";
import { useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import Modal from "../../../myfin_v2/elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { Button } from "../../../myfin_v2/elements/Button";
import commoncss from "../../../myfin_v2/css/common.module.css";
import { createKeyManagerialPerson, updateKeyManagerialPerson } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";


import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../../myfin_v2/assets/icons/calender.svg";

export const customStyles = {
    control: (provided, state) => ({
        ...provided,
        backgroundColor: '#f4faf5',
        borderColor: '#c2e6d1',
        color: '#b3c0bd',
        boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
        borderWidth: '1px',
        borderRadius: '10px',
        '&:hover': {
            borderColor: '#b3c0bd',
        },
        minHeight: '38px',
        height: '38px',
    }),
    valueContainer: (provided) => ({
        ...provided,
        padding: '0 8px',
        display: 'flex',
        alignItems: 'center',
    }),
    input: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        margin: 0,
        padding: 0,
    }),
    placeholder: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        fontSize: '14px',
        margin: 0,
    }),
    singleValue: (provided) => ({
        ...provided,
        color: '#4d6d64',
        fontSize: '14px',
        margin: 0,
    }),
    multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e0f5e9',
        borderRadius: '0.25rem',
        border: '1px solid #c2e6d1',
        width: 'fit-content',
    }),
    multiValueLabel: (provided) => ({
        ...provided,
        color: '#4d6d64',
    }),
    multiValueRemove: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            backgroundColor: '#c2e6d1',
            color: '#4f665f',
        },
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        color: '#b3c0bd',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        color: '#1A4338',
        fontWeight: 400,
        ':hover': {
            color: '#1A4338',
            fontWeight: 400,
        },
    }),
    clearIndicator: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        ':hover': {
            color: '#4f665f',
        },
    }),
    menu: (provided) => ({
        ...provided,
        backgroundColor: '#ffffff',
        border: '1px solid #c2e6d1',
        borderRadius: '6px',
        boxShadow: '0 0 0 1px #c2e6d1',
        marginTop: '6px',
        zIndex: 10,
    }),
    menuList: (provided) => ({
        ...provided,
        padding: '4px',
        borderRadius: '6px',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
            ? '#f4faf5'
            : state.isFocused
                ? '#f8f9f9'
                : 'transparent',
        color: '#4f665f',
        padding: '10px 12px',
        cursor: 'pointer',
        fontSize: '14px',
        borderRadius: '8px',
        marginBottom: '4px',
    }),
    noOptionsMessage: (provided) => ({
        ...provided,
        color: '#b3c0bd',
        padding: '8px 12px',
    }),
};

const KeyManagerialPersonsModal = ({ handleClose, data, type, investmentID, classOfShareOptions, refreshData, companyId }) => {
    const [name, setName] = useState(type === "edit" ? data?.name : "");
    const [designation, setDesignation] = useState(
        type === "edit" ? data?.designation : ""
    )
   const [appointmentDate, setAppointmentDate] = useState(
    type === "edit" && data?.dateOfAppointment
        ? dayjs(data.dateOfAppointment)
        : null
    );

    const [resignationDate, setResignationDate] = useState(
    type === "edit" && data?.dateOfResignation
        ? dayjs(data.dateOfResignation)
        : null
    );

    const [apiResponse, setApiResponse] = useState(null);
    const handleSubmit = async () => {
  try {
    const payload = {
      companyID: companyId,  
      name: name,
      designation: designation,
      dateOfAppointment: appointmentDate
        ? appointmentDate.format("DD-MM-YYYY")
        : "",
      dateOfResignation: resignationDate
        ? resignationDate.format("DD-MM-YYYY")
        : "",
    };

    console.log(payload);

    let response;

    if (type === "edit") {
      response = await updateKeyManagerialPerson(investmentID, data._id, payload);
    } else {
      response = await createKeyManagerialPerson(investmentID, payload);
    }

    if (response.status === 200) {
      swal("Success", type === "edit" ? "Updated Successfully" : "Created Successfully", "success").then(() => {
          refreshData();
          handleClose();
      });
    }

  } catch (error) {
    console.error("Error saving Key Managerial Person:", error);
    swal("Error", error?.response?.data?.error || error?.response?.data?.message || "Something went wrong ❌", "error");
  }
};


    return(
        <>
            <Modal
                width="500px"
                title={type === "edit" ? "Edit Key Managerial Personnel" : "Add Key Managerial Personnel"}
                bodycss={commoncss.unsetPadding}
                headerActions={
                    <CloseIcon
                        className="clickable"
                        onClick={handleClose}
                    />
                }
                footerActions={
                    <>
                        <Button
                            btnColor={buttoncss.secondary}
                            label="Cancel"
                            onClick={handleClose}
                        />
                        <Button
                            btnColor={buttoncss.primary}
                            label={type === "edit" ? "Update" : "Add Key Managerial Personnel"}
                            onClick={handleSubmit}
                        />
                    </>
                }
            >

                <div className={commoncss.pd1530}>
                    <InputGroup
                        label="Name"
                        inputs={[
                        <>
                            <input
                                type="text"
                                placeholder="Enter name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                // defaultValue={type === "edit" ? data?.name : ""}
                            />
                        </>,
                        ]}
                    />
                    <InputGroup
                        label="Designation"
                        inputs={[
                        <>
                            <input
                                type="text"
                                placeholder="Enter designation"
                                value={designation}
                                onChange={(e) => setDesignation(e.target.value)}
                            />
                        </>,
                        ]}
                    />
                    <InputGroup
                        label="Date of Appointment"
                        inputs={[
                            <>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                        <MobileDatePicker
                                            className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                            value={appointmentDate}
                                            onChange={(newValue) => setAppointmentDate(newValue)}
                                            format="DD-MMM-YYYY"
                                            slotProps={{
                                                textField: {
                                                    InputProps: {
                                                        disableUnderline: true,
                                                    },
                                                    inputProps: {
                                                        placeholder: "DD-MM-YYYY",
                                                    },
                                                    sx: {
                                                        '& fieldset': {
                                                            border: 'none',
                                                        },
                                                    },
                                                },
                                            }}
                                        />

                                    </DemoContainer>
                                </LocalizationProvider>
                                <span className="icon">
                                    <CalenderIcon
                                        className="vaMiddle"
                                        width={20}
                                        height={20}
                                    />
                                </span>
                            </>,
                        ]}
                    />
                    <InputGroup
                        label="Date of Resignation"
                        inputs={[
                            <>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                        <MobileDatePicker
                                            className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                            format="DD-MMM-YYYY"
                                            value={resignationDate}
                                            onChange={(newValue) => setResignationDate(newValue)}
                                            slotProps={{
                                                textField: {
                                                    InputProps: {
                                                        disableUnderline: true,
                                                    },
                                                    inputProps: {
                                                        placeholder: "DD-MM-YYYY",
                                                    },
                                                    sx: {
                                                        '& fieldset': {
                                                            border: 'none',
                                                        },
                                                    },
                                                },
                                            }}
                                        />

                                    </DemoContainer>
                                </LocalizationProvider>
                                <span className="icon">
                                    <CalenderIcon
                                        className="vaMiddle"
                                        width={20}
                                        height={20}
                                    />
                                </span>
                            </>,
                        ]}
                    />
                </div>
                
            </Modal>
        </>
    )

}

export default KeyManagerialPersonsModal;